import { j as n } from "./jsx-runtime-944c88e2.js";
import { Icon as o } from "./icon.js";
import "react";
import "./index-efd35e77.js";
const e = (r) => /* @__PURE__ */ n.jsx(o, { ...r, icon: "spinner", className: `fa-spin ${r.className}` });
export {
  e as Spinner
};
